export default __webpack_public_path__ + "static/media/databases.349d7ac1.svg";